import React from 'react';
import {Link} from "react-router-dom";
import Logo from '../../components/logo/Logo';
import FooterData from '../../data/Footer/footerItem.json';
import FooterLinkItem from '../../components/Footer/FooterLinkItem.jsx';

const Footer = () => {
    return (
        <div style={{backgroundColor:'#4A4A54'}} className="footer-section section footer-bg-color">
            <div className="container">
                <div className="row mb-lg-14 mb-md-10 mb-6">

                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 col-12 mb-6">
                        <div className="footer-widget">
                            <div className="footer-logo">
                               <img
                               className='w-75'
                        src="/services/luma logo white.png"
                        alt=""
                        
                        
                    />
                            </div>
                            <div className="footer-widget-content">
                                <div className="content">


                                    {/* <p><Link to={process.env.PUBLIC_URL + "/"}>(+1) 212-946-2701</Link></p> */}
                                    {/* <p>
  <a href="mailto:support@Lumademand.com">support@Lumademand.com</a>
</p> */}
                                </div>
                                <div className="footer-social-inline">
                                    {/* <a href="#"><i className="fab fa-twitter-square"></i></a>
                                    <a href="#"><i className="fab fa-facebook-square"></i></a>
                                    <a href="#"><i className="fab fa-instagram"></i></a> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {FooterData && FooterData.map((single, key) => {
                            return(
                                <div key={key} className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-6">
                                    <FooterLinkItem data={single} key={key} />
                                </div>
                            ); 
                    })}


                </div>

                <div className="row">
                    <div className="col">
                        <p className="copyright">&copy; {new Date().getFullYear()} <strong>Copyright</strong> - All Rights Reserved</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer
